import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { TableData } from './table.component.interface';

@Component({
  selector: 'hospitable-table',
  templateUrl: './table.component.html',
  styleUrls: ['./table.component.scss'],
})
export class TableComponent implements OnInit {
  /** Table data including columns and data source. The data object contains:
   * - displayedColumns: Array of column names to display
   * - dataSource: Array of data objects to display in the table
   * - meta: Optional pagination metadata */
  @Input() data: TableData;
  @Output() pageChanged = new EventEmitter<number>();
  dataSource: MatTableDataSource<unknown>;

  ngOnInit() {
    this.dataSource = new MatTableDataSource(this.data.dataSource);
  }

  onPageChanged(page: number) {
    this.pageChanged.emit(page);
  }
}
